import gql from 'graphql-tag';
const MAT_MAN_MATCH_ACTIVITY_FRAGMENT = gql `
  fragment MatManMatchActivityFragment on MatManMatchActivity {
    imageLocation
    availableShapes {
      shape
      audio
    }
    rounds {
      roundIndex
      shape
      empty
      completed
      selected
      unselected
      draggableShapes {
        id
        shape
        selected
        unselected
      }
    }
  }
`;
export default MAT_MAN_MATCH_ACTIVITY_FRAGMENT;
